import { Link } from 'react-router-dom';
import { novels } from '@/mocks/novels';

export default function FeaturedNovels() {
  const featured = novels.slice(0, 6);

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              精选推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-2">编辑团队精心挑选的必读佳作</p>
          </div>
          <Link
            to="/category/urban-revenge"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-xs"></i>
            </span>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {featured.map((novel) => (
            <Link
              key={novel.id}
              to={`/article/${novel.id}`}
              className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="flex p-4 gap-4">
                <div className="w-[90px] h-[126px] flex-shrink-0 rounded-md overflow-hidden">
                  <img
                    src={novel.coverImage}
                    alt={novel.title}
                    title={`${novel.title} - 都市美艳后宫推荐`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="flex-1 min-w-0 flex flex-col justify-between">
                  <div>
                    <h3 className="font-heading text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors duration-200 line-clamp-2">
                      {novel.title}
                    </h3>
                    <p className="text-xs text-foreground-500 mt-1">
                      <span className="w-3 h-3 inline-flex items-center justify-center mr-0.5">
                        <i className="ri-user-line text-[10px]"></i>
                      </span>
                      {novel.author}
                    </p>
                    <p className="text-xs text-foreground-400 mt-2 line-clamp-3 leading-relaxed">
                      {novel.description}
                    </p>
                  </div>
                  <div className="flex items-center gap-3 mt-3">
                    <span className="inline-flex items-center gap-0.5 text-xs text-accent-500">
                      <span className="w-3 h-3 flex items-center justify-center">
                        <i className="ri-star-fill text-[10px]"></i>
                      </span>
                      {novel.rating}
                    </span>
                    <span className="text-xs text-foreground-400">{novel.wordCount}</span>
                    <span className={`text-xs px-1.5 py-0.5 rounded-full ${
                      novel.status === 'completed'
                        ? 'bg-secondary-100 text-secondary-700'
                        : 'bg-accent-100 text-accent-700'
                    }`}>
                      {novel.status === 'completed' ? '已完结' : '连载中'}
                    </span>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/urban-revenge"
            className="inline-flex items-center gap-1 text-sm text-primary-500 font-medium whitespace-nowrap cursor-pointer"
          >
            查看全部推荐
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-xs"></i>
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}